/* Wrapper for the map section */
.wrapper {
  margin: 0 0 24px 0;
}

/* Map container — flat style matching tables */
.mapContainer {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--box-border-color, #e0e0e0);
  /* Isolate Leaflet's z-index stack so controls (z-index: 1000) don't
     escape and overlap the app sidebar (also z-index: 1000). */
  isolation: isolate;
}

.map {
  height: 720px;
  width: 100%;
  background: var(--light-grey, #f6f7f9);
}

/* Shrink Leaflet attribution */
.mapContainer :global(.leaflet-control-attribution) {
  font-size: 0.6rem;
  opacity: 0.5;
}

/* Flatten Leaflet zoom controls */
.mapContainer :global(.leaflet-control-zoom) {
  border: 1px solid var(--box-border-color, #e0e0e0);
  border-radius: 0;
  box-shadow: none;
}

.mapContainer :global(.leaflet-control-zoom a) {
  border-radius: 0;
  color: var(--secondary-text, #666);
  border-bottom-color: var(--box-border-color, #e0e0e0);
}

.mapContainer :global(.leaflet-control-zoom a:hover) {
  color: var(--main-text, #333);
  background: var(--light-grey, #f6f7f9);
}

/* Override Leaflet popup chrome */
.mapContainer :global(.leaflet-popup-content-wrapper) {
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0;
}

.mapContainer :global(.leaflet-popup-content) {
  margin: 0;
}

.mapContainer :global(.leaflet-popup-tip-container) {
  display: none;
}

/* Popup content */
.popup {
  padding: 10px 14px;
  font-size: 0.8rem;
  line-height: 1.4;
  max-width: 280px;
}

.popupLabel {
  display: block;
  font-size: 0.8rem;
  color: var(--main-text, #333);
  margin-bottom: 2px;
}

.popupList {
  margin: 4px 0 0 0;
  padding: 0;
  list-style: none;
}

.popupListItem {
  font-size: 0.78rem;
  line-height: 1.5;
  color: var(--secondary-text, #555);
}

.popupListItem + .popupListItem {
  border-top: 1px solid var(--box-border-color, #eee);
}

.popupLink {
  display: block;
  width: 100%;
  background: none;
  border: none;
  padding: 5px 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-align: left;
  transition: color 0.1s;
}

.popupLink:hover {
  color: var(--main-blue, #4c90f0);
}

/* Brief highlight when scrolling to a block from the map */
:global(.bdm-highlight) {
  background: rgba(76, 144, 240, 0.1);
  transition: background 0.6s ease;
}

:global(.bdm-highlight-fade) {
  background: transparent;
  transition: background 0.8s ease;
}

/* Mobile */
@media (max-width: 768px) {
  .map {
    height: 400px;
  }
}
